<template>
    <div class="slider-container position-relative">
        <div class="row mx-0">
            <b-carousel :interval="3000" indicators class="w-100" v-if="slides">
                <b-carousel-slide v-for="(slide, index) in slides" :img-src="getIcon(slide.images.image)" :key="index" v-if="slide.type == 1"
                                  :img-alt="'SegaSlot ' + slide.title"></b-carousel-slide>
            </b-carousel>
        </div>
    </div>
</template>

<script>
    import Config from "@/config";
    export default {
      computed: {
        slides() {
          return this.$store.getters['getSlides']
        }
      },
      methods: {
        getIcon(icon) {
          return  Config.mainStorageUrl + icon
        }
      }
    }
</script>

<style>
    .slider-container .carousel-indicators {
        margin-bottom: 0;
    }

    .slider-container .carousel-indicators li {
        width: 25% !important;
        height: 1px !important;
        margin: 0 !important;
        border: none !important;
        outline: none !important;
        background-color: #010f20 !important;
    }

    .slider-container .carousel-indicators li.active {
        background-image: linear-gradient(to right, #e5001b, #fb3721);
    }
</style>
